module.exports = __webpack_public_path__ + "img/1.f87c15a2.png";